/* NAGAIA kit contents v20:
   v20 (2026-07-27) — two fixes to the liquids/tools grid:
   (a) SHORT display labels. The catalogue titles ("Essential Liquid
       Replacement Brush", "Premium Nail File 180/100 Grit") ran to four wrapped
       lines in a 4-column grid, so every row was a different height and the
       block read as a ragged waterfall. LABEL below is display copy only — the
       keys still match the product titles used by IMG and KITS, so nothing
       downstream needs to know about it.
   (b) Labels clamp to two lines and reserve two lines of height, so all cells
       in a row are the same height whatever the name length.
   v19: mobile grid tracks are minmax(0,1fr), not 1fr. 1fr means
   minmax(auto,1fr) and the auto minimum is min-content; inside the cart's item
   card (which has padding, unlike the builder column) four min-content tracks
   exceeded the available width, the grid blew out, and overflow:hidden silently
   ate the fourth swatch. overflow:hidden now only exists while folded.
   v18: swatch grid mirrors the kit builder (.nk-sw-grid in
   assets/nagaia-kit-page.css). DO NOT invent new swatch metrics here; if the
   builder's grid changes, change this to match.
     mobile : 4 columns, gap 12px, image up to 72px
     >=768  : repeat(auto-fill, minmax(85px, 1fr)), gap 14px, image up to 80px
   Overflow rule is by ROWS, not by count: past two rows folds behind "Show all
   N colors", measured at runtime. The builder's 400px scroll box is
   deliberately NOT copied: a nested scroll area between the price and the
   checkout button is the obstacle this round set out to remove.
   The old horizontal scroll strip is gone: Brief records that desktop
   horizontal scroll here cannot be driven by a mouse wheel or drag.
   NOTE: swatches are SQUARE. A round crop was tried and reverted — the color
   photos are portrait nail tips on white, so a circle cuts the tip.
   v16: cascade cleanup is a SINGLE batched /cart/update.js call. v15: per-build
   _kb token attribution. v14: qty-aware, per-row panels. */
(function () {
  var IMG = {
    'Primer': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIADipEssentialLiquidPrimerLiquid.jpg?v=1710938665',
    'Base Coat': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIADipEssentialLiquidBaseCoat.jpg?v=1710938781',
    'Activator': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIADipEssentialLiquidActivator.jpg?v=1710938708',
    'Top Coat': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIADipEssentialLiquidTopCoat_646376cd-37db-48e1-9c81-2b0b3855ec76.jpg?v=1710938787',
    'Brush Saver': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIADipEssentialLiquidBrushSaver_49ee59ca-5d6b-4e14-9281-5110b6d06382.jpg?v=1710938798',
    'Clear Build Powder': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NBPClearPowder.jpg?v=1774770039',
    'Essential Liquid Replacement Brush': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/3Replacementbrush.jpg?v=1689045394',
    'Dust Brush': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIANailDustBrush.jpg?v=1710938941',
    'Fresh Nail Removal Foil Wrap': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIANailsRemovalWrap_9.jpg?v=1716530828',
    'Cuticle Pusher': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIANailToolsCuticlePusher.jpg?v=1710938489',
    'Buffer Block': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIABufferBlock120Grid.png?v=1710938978',
    'Premium Nail File 180/100 Grit': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/1_NAGAIA_Premium_Nail_File_Main_Image_10_Pc.jpg?v=1726153572',
    'Cuticle Milk': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIANail_SkinCareCuticleMilk_5e632a33-5b9e-458c-a105-516d3a8c922d.jpg?v=1710938802',
    'Cuticle Oil': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIANail_SkinCareCuticleOil_1_00d49778-c1e9-4b67-8489-19a36921a346.jpg?v=1710938805',
    'Hand Mask': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIASkinCareHandMask.jpg?v=1710938550',
    'Foot Mask': 'https://cdn.shopify.com/s/files/1/0618/7673/2118/files/NAGAIASkinCareFootMask.jpg?v=1710938538'
  };
  /* Display copy only. Keys must stay identical to the IMG/KITS keys. */
  var LABEL = {
    'Essential Liquid Replacement Brush': 'Replacement Brush',
    'Fresh Nail Removal Foil Wrap': 'Removal Wraps',
    'Premium Nail File 180/100 Grit': 'Nail File',
    'Clear Build Powder': 'Clear Powder'
  };
  function shortName(n) { return LABEL[n] || n; }

  var CORE3 = [['Base Coat',1],['Activator',1],['Top Coat',1]];
  var KITS = {
    essential: [['Primer',1],['Base Coat',1],['Activator',1],['Top Coat',1],['Brush Saver',1],['Essential Liquid Replacement Brush',1],['Dust Brush',1],['Fresh Nail Removal Foil Wrap',1],['Cuticle Pusher',1],['Buffer Block',2],['Premium Nail File 180/100 Grit',3]],
    deluxe:   [['Primer',1],['Base Coat',1],['Activator',1],['Top Coat',1],['Brush Saver',1],['Essential Liquid Replacement Brush',1],['Dust Brush',1],['Fresh Nail Removal Foil Wrap',2],['Cuticle Pusher',1],['Cuticle Milk',1],['Buffer Block',2],['Premium Nail File 180/100 Grit',3]],
    ultimate: [['Primer',1],['Base Coat',1],['Activator',1],['Top Coat',1],['Brush Saver',1],['Essential Liquid Replacement Brush',1],['Dust Brush',1],['Fresh Nail Removal Foil Wrap',3],['Cuticle Milk',1],['Cuticle Oil',1],['Hand Mask',1],['Foot Mask',1],['Cuticle Pusher',1],['Buffer Block',2],['Premium Nail File 180/100 Grit',3]],
    'the capsule': CORE3,
    'the studio':  CORE3,
    'the salon':   CORE3
  };
  var KIT_HANDLES = ['dip-powder-kit','switch-kit'];

  var gItems           = null;
  var gColorVariantIds = {};
  var gColorHandles    = {};
  var gFetchPending    = false;
  var gCleaned         = false;

  function injectCSS() {
    if (document.getElementById('nag-kc-css')) return;
    var st = document.createElement('style'); st.id = 'nag-kc-css';
    st.textContent = [
      '.nag-kc-wrapper{display:block;border-bottom:1px solid #E2DCD5}',
      '.nag-kc-wrapper .cart-item{border-bottom:none !important}',
      '.nag-kc-wrapper [class*="quantity"],.nag-kc-wrapper [class*="qty"],.nag-kc-wrapper input[type="number"],.nag-kc-wrapper input[name*="updates"]{display:none !important}',
      '.nag-kc-panel{display:block;width:100%;box-sizing:border-box;padding:13px 0 16px}',
      '.nag-kc-head{display:flex;align-items:baseline;gap:10px;margin:0 0 10px}',
      '.nag-kc-lbl{font-size:12px;font-weight:800;color:#1A1A1A}',
      '.nag-kc-hint{font-size:11px;color:#9B958E;white-space:nowrap}',
      '.nag-kc-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px;align-items:start}',
      '@media (min-width:768px){.nag-kc-grid{grid-template-columns:repeat(auto-fill,minmax(85px,1fr));gap:14px}}',
      '.nag-kc-sw2,.nag-kc-cell{display:block;width:100%;min-width:0;padding:0;border:0;background:none;font:inherit;text-align:center}',
      '.nag-kc-sw2{cursor:pointer}',
      '.nag-kc-dot{display:block;width:100%;max-width:72px;aspect-ratio:1;border-radius:12px;border:1px solid #E2DCD5;background:#F5F2F0 center/cover no-repeat;margin:0 auto 5px}',
      '@media (min-width:768px){.nag-kc-dot{max-width:80px}}',
      '.nag-kc-nm{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.4em;font-size:11px;font-weight:600;line-height:1.2;color:#4A4A4A;overflow-wrap:anywhere}',
      '.nag-kc-more{display:flex;justify-content:center;margin:12px 0 0}',
      '.nag-kc-morebtn{font-size:12px;font-weight:600;color:#C92072;background:none;border:0;padding:4px 6px;cursor:pointer;font-family:inherit}',
      '.nag-kc-liq{border-top:1px solid #E2DCD5;margin:14px 0 0;padding:12px 0 0}',
      '.nag-kc-liq>summary{cursor:pointer;list-style:none;display:flex;align-items:center;gap:10px;font-size:12px;color:#4A4A4A}',
      '.nag-kc-liq>summary::-webkit-details-marker{display:none}',
      '.nag-kc-more-inline{color:#C92072;font-weight:600;white-space:nowrap;margin-left:auto}',
      '.nag-kc-chev{display:inline-block;transition:transform .2s ease}',
      '.nag-kc-liq[open]>summary .nag-kc-chev{transform:rotate(180deg)}',
      '.nag-kc-liq .nag-kc-grid{margin-top:12px}',
      '.nag-kc-lb{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(26,26,26,.62);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px}',
      '.nag-kc-lb__box{background:#fff;border-radius:14px;padding:20px 18px;max-width:320px;width:100%;text-align:center;position:relative}',
      '.nag-kc-lb__img{width:180px;height:180px;border-radius:12px;object-fit:cover;border:1px solid #E2DCD5;background:#F5F2F0;display:block;margin:0 auto 12px}',
      '.nag-kc-lb__nm{font-size:15px;font-weight:700;color:#1A1A1A;margin:0 0 4px}',
      '.nag-kc-lb__sub{font-size:12px;color:#6B6660}',
      '.nag-kc-lb__x{position:absolute;top:6px;right:10px;border:0;background:none;font-size:24px;line-height:1;color:#6B6660;cursor:pointer;padding:2px 6px}',
      '.template-cart .cart-column--total{display:none !important}',
      '.cart-column--discount .product-price__reduced{display:none !important}',
      '.nag-kc-hide{display:none !important}'
    ].join('');
    document.head.appendChild(st);
  }

  function tierOf(item) { return KITS[(item.variant_title || '').toLowerCase().trim()]; }
  function isKitHandle(h) { return KIT_HANDLES.indexOf(h) !== -1; }
  function propOf(item, key) { return (item.properties && item.properties[key]) || ''; }

  function buildAssignments() {
    var kitLines = [], colorEntries = [];
    gItems.forEach(function(it, idx){
      if (isKitHandle(it.handle) && tierOf(it)) kitLines.push({ item: it, idx: idx, colors: [] });
      else if (propOf(it, '_kit')) colorEntries.push({ item: it, idx: idx });
    });
    var byToken = {};
    var legacyByHandle = {};
    kitLines.forEach(function(k){
      var t = propOf(k.item, '_kb');
      if (t) byToken[t] = k;
      else (legacyByHandle[k.item.handle] = legacyByHandle[k.item.handle] || []).push(k);
    });
    colorEntries.forEach(function(c){
      var tok = propOf(c.item, '_kb');
      var tag = propOf(c.item, '_kit');
      if (tok && byToken[tok]) { byToken[tok].colors.push(c.item); return; }
      var handle = isKitHandle(tag) ? tag : null;
      var target = null, i;
      if (handle) {
        var arr = legacyByHandle[handle] || [];
        for (i = 0; i < arr.length; i++) { if (arr[i].idx < c.idx) target = arr[i]; }
        if (!target && arr.length) target = arr[0];
        if (!target) {
          for (i = 0; i < kitLines.length; i++) { if (kitLines[i].item.handle === handle) { target = kitLines[i]; break; } }
        }
      } else if (kitLines.length) {
        target = kitLines[0];
      }
      if (target) target.colors.push(c.item);
    });
    return kitLines;
  }

  /* Returns true if a cleanup was fired (page will reload). */
  function cascadeCleanup() {
    if (gCleaned || !gItems) return false;
    var tokens = {}, present = {}, anyKit = false;
    gItems.forEach(function(it){
      if (isKitHandle(it.handle)) {
        anyKit = true;
        present[it.handle] = true;
        var t = propOf(it, '_kb');
        if (t) tokens[t] = true;
      }
    });
    var updates = {}, count = 0;
    gItems.forEach(function(it){
      var tag = propOf(it, '_kit');
      if (!tag) return;
      var tok = propOf(it, '_kb');
      var orphan = false;
      if (tok) {
        orphan = !tokens[tok];
      } else if (isKitHandle(tag)) {
        orphan = !present[tag];
      } else {
        orphan = !anyKit;
      }
      if (orphan) { updates[it.key] = 0; count++; }
    });
    if (!count) return false;
    gCleaned = true;
    fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r){ if (!r.ok) throw new Error(); return r.json(); })
    .then(function(){ window.location.reload(); })
    .catch(function(){ gCleaned = false; });
    return true;
  }

  function stripKit(t) {
    t = (t || '').toString();
    var i = t.toLowerCase().indexOf('kit only');
    if (i >= 0) t = t.slice(0, i) + t.slice(i + 8);
    return t.trim();
  }

  function lbl(text) {
    var d = document.createElement('span'); d.className = 'nag-kc-lbl'; d.textContent = text; return d;
  }

  /* In-place color preview. Never navigates: leaving the cart to check a shade
     is the single easiest way to lose a shopper who had already committed. */
  function openLightbox(ci, name) {
    var old = document.getElementById('nag-kc-lb');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var bg  = document.createElement('div'); bg.id = 'nag-kc-lb'; bg.className = 'nag-kc-lb';
    var box = document.createElement('div'); box.className = 'nag-kc-lb__box';
    var x   = document.createElement('button'); x.type = 'button'; x.className = 'nag-kc-lb__x';
    x.setAttribute('aria-label', 'Close'); x.innerHTML = '&times;';
    var im  = document.createElement('img'); im.className = 'nag-kc-lb__img'; im.alt = name;
    if (ci.image) im.src = ci.image;
    var nm  = document.createElement('div'); nm.className = 'nag-kc-lb__nm'; nm.textContent = name;

    box.appendChild(x); box.appendChild(im); box.appendChild(nm);

    var bits = [];
    if (ci.sku) bits.push(ci.sku);
    var vt = (ci.variant_title || '').trim();
    if (vt && vt.toLowerCase() !== 'default title') bits.push(vt);
    if (bits.length) {
      var sb = document.createElement('div'); sb.className = 'nag-kc-lb__sub';
      sb.textContent = bits.join(' \u00B7 '); box.appendChild(sb);
    }

    bg.appendChild(box); document.body.appendChild(bg);

    function close() {
      if (bg.parentNode) bg.parentNode.removeChild(bg);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) close(); }
    x.addEventListener('click', close);
    bg.addEventListener('click', function(e){ if (e.target === bg) close(); });
    document.addEventListener('keydown', onKey);
  }

  function swatchCell(imgUrl, label, onClick) {
    var node = document.createElement(onClick ? 'button' : 'div');
    node.className = onClick ? 'nag-kc-sw2' : 'nag-kc-cell';
    if (onClick) { node.type = 'button'; node.setAttribute('aria-label', 'Preview ' + label); }
    var dot = document.createElement('span'); dot.className = 'nag-kc-dot';
    if (imgUrl) dot.style.backgroundImage = 'url(' + imgUrl + ')';
    var nm = document.createElement('span'); nm.className = 'nag-kc-nm'; nm.textContent = label;
    nm.title = label;
    node.appendChild(dot); node.appendChild(nm);
    if (onClick) node.addEventListener('click', function(e){ e.preventDefault(); onClick(); });
    return node;
  }

  /* Fold by ROWS, measured live. Anything past two rows hides behind a control
     that names how many are hidden. Deliberately not a fixed item count: change
     the swatch size or the breakpoint and this still does the right thing. */
  function foldPastTwoRows(grid, holder, total) {
    if (!grid.children.length) return;
    var run = function () {
      var first = grid.children[0];
      if (!first || !first.offsetHeight) return;
      var cs = window.getComputedStyle(grid);
      var rowGap = parseFloat(cs.rowGap || cs.gridRowGap) || 12;
      var twoRows = (first.offsetHeight * 2) + rowGap;
      if (grid.scrollHeight <= twoRows + 4) return;

      var collapsedLabel = 'Show all ' + total + ' colors <span class="nag-kc-chev">\u2304</span>';
      var openLabel = 'Show fewer <span class="nag-kc-chev" style="transform:rotate(180deg)">\u2304</span>';

      function collapse() { grid.style.maxHeight = twoRows + 'px'; grid.style.overflow = 'hidden'; }
      function expand() { grid.style.maxHeight = ''; grid.style.overflow = ''; }
      collapse();

      var bar = document.createElement('div'); bar.className = 'nag-kc-more';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'nag-kc-morebtn';
      btn.innerHTML = collapsedLabel;
      btn.addEventListener('click', function () {
        if (grid.style.maxHeight) { expand(); btn.innerHTML = openLabel; }
        else { collapse(); btn.innerHTML = collapsedLabel; }
      });
      bar.appendChild(btn);
      holder.appendChild(bar);
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else setTimeout(run, 60);
  }

  function buildPanel(list, colors, kitQty) {
    kitQty = kitQty || 1;
    var colorCount = 0;
    (colors || []).forEach(function(ci){ colorCount += (ci.quantity || 1); });

    var d = document.createElement('div'); d.className = 'nag-kc-panel';

    if (colors && colors.length) {
      var head = document.createElement('div'); head.className = 'nag-kc-head';
      head.appendChild(lbl('Colors In Your Kit (' + colorCount + ')'));
      var hint = document.createElement('span'); hint.className = 'nag-kc-hint';
      hint.textContent = 'Tap to preview';
      head.appendChild(hint);
      d.appendChild(head);

      var grid = document.createElement('div'); grid.className = 'nag-kc-grid';
      colors.forEach(function(ci){
        var name = stripKit(ci.product_title || ci.title || '');
        var qty  = ci.quantity || 1;
        grid.appendChild(swatchCell(ci.image, (qty > 1 ? qty + 'x ' : '') + name, function(){
          openLightbox(ci, name);
        }));
      });
      d.appendChild(grid);
      foldPastTwoRows(grid, d, colorCount);
    }

    var det = document.createElement('details'); det.className = 'nag-kc-liq';
    var sm  = document.createElement('summary');
    var st  = document.createElement('span');
    st.textContent = 'Liquids, tools and removal included';
    var more = document.createElement('span'); more.className = 'nag-kc-more-inline';
    more.innerHTML = 'View all <span class="nag-kc-chev">\u2304</span>';
    sm.appendChild(st); sm.appendChild(more);
    det.appendChild(sm);

    var lgrid = document.createElement('div'); lgrid.className = 'nag-kc-grid';
    list.forEach(function(c){
      lgrid.appendChild(swatchCell(IMG[c[0]], (c[1] * kitQty) + 'x ' + shortName(c[0]), null));
    });
    det.appendChild(lgrid);
    d.appendChild(det);

    return d;
  }

  function rowHandleOf(row) {
    if (row.querySelector('a[href*="/products/switch-kit"]')) return 'switch-kit';
    if (row.querySelector('a[href*="dip-powder-kit"]')) return 'dip-powder-kit';
    return null;
  }

  function findKitRows() {
    var out = [];
    var items = document.querySelectorAll('.cart-item');
    for (var i=0;i<items.length;i++) {
      var h = rowHandleOf(items[i]);
      if (h) out.push({ row: items[i], handle: h });
    }
    if (out.length) return out;
    var anchors = document.querySelectorAll('a');
    for (var a=0;a<anchors.length;a++) {
      var href = anchors[a].getAttribute('href')||'';
      var hh = null;
      if (href.indexOf('/products/switch-kit')!==-1) hh='switch-kit';
      else if (href.indexOf('dip-powder-kit')!==-1) hh='dip-powder-kit';
      if (!hh) continue;
      var row = anchors[a].closest('[class*=cart-item]')||anchors[a].closest('li')||anchors[a].closest('tr');
      if (row) {
        var dup=false;
        for (var o=0;o<out.length;o++){ if(out[o].row===row){dup=true;break;} }
        if(!dup) out.push({ row: row, handle: hh });
      }
    }
    return out;
  }

  function hideEl(el) {
    if (!el) return;
    el.classList.add('nag-kc-hide');
    el.style.setProperty('display','none','important');
  }

  function rowMatchesColor(html) {
    var low = html.toLowerCase();
    if (low.indexOf('kit only')!==-1 || low.indexOf('kit-only')!==-1) return true;
    var vid, h;
    for (vid in gColorVariantIds) {
      if (html.indexOf('variant='+vid)!==-1 || html.indexOf('updates['+vid+']')!==-1) return true;
    }
    for (h in gColorHandles) { if (html.indexOf('/'+h)!==-1) return true; }
    return false;
  }

  function quickHide() {
    var kitRows = findKitRows();
    if (!kitRows.length) return;
    var kitRow = kitRows[0].row;
    if (!kitRow.parentElement) return;
    var wrapper = kitRow.closest('.nag-kc-wrapper') ||
      (kitRow.parentElement.classList.contains('nag-kc-wrapper') ? kitRow.parentElement : null);
    var container = wrapper ? wrapper.parentElement : kitRow.parentElement;
    if (!container) return;
    var kids = container.children;
    for (var i=0;i<kids.length;i++) {
      var row = kids[i];
      if (row.classList.contains('nag-kc-wrapper')) continue;
      var isKitRow = false;
      for (var k=0;k<kitRows.length;k++){ if(kitRows[k].row===row){isKitRow=true;break;} }
      if (isKitRow) continue;
      if (rowMatchesColor(row.innerHTML||'')) hideEl(row);
    }
  }

  function apply() {
    injectCSS();
    if (!gItems) return;
    var kitRows = findKitRows();
    if (!kitRows.length) return;
    var kitLines = buildAssignments();
    if (!kitLines.length) return;

    var linesByHandle = {};
    kitLines.forEach(function(kl){
      (linesByHandle[kl.item.handle] = linesByHandle[kl.item.handle] || []).push(kl);
    });
    var cursor = {};
    kitRows.forEach(function(kr){
      var arr = linesByHandle[kr.handle] || [];
      var pos = cursor[kr.handle] || 0;
      var kl = arr[pos];
      cursor[kr.handle] = pos + 1;
      if (!kl) return;
      var wrapper = kr.row.closest('.nag-kc-wrapper') ||
        (kr.row.parentElement && kr.row.parentElement.classList.contains('nag-kc-wrapper') ? kr.row.parentElement : null);
      if (wrapper) return;
      if (!kr.row.parentElement) return;
      wrapper = document.createElement('div'); wrapper.className='nag-kc-wrapper';
      kr.row.parentElement.insertBefore(wrapper, kr.row);
      wrapper.appendChild(kr.row);
      wrapper.appendChild(buildPanel(tierOf(kl.item), kl.colors, kl.item.quantity || 1));
    });
    quickHide();
  }

  function fetchAndApply() {
    if (gFetchPending) return;
    gFetchPending = true;
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        gFetchPending = false;
        gItems = (cart&&cart.items)||[];
        gColorVariantIds = {};
        gColorHandles    = {};
        gItems.forEach(function(it){
          var isKitOnly = (it.properties&&it.properties._kit) ||
                          (it.title||'').toLowerCase().indexOf('kit only')!==-1;
          if (isKitOnly) {
            gColorVariantIds[it.variant_id] = true;
            if (it.handle) gColorHandles[it.handle] = true;
          }
        });
        var cleaning = cascadeCleanup();
        quickHide();
        if (!cleaning) apply();
      })
      .catch(function(){ gFetchPending=false; });
  }

  var debTimer = null;
  function onMutation() {
    quickHide();
    clearTimeout(debTimer);
    debTimer = setTimeout(fetchAndApply, 60);
  }

  function run() {
    injectCSS();
    fetchAndApply();
    try {
      var mo = new MutationObserver(onMutation);
      mo.observe(document.body, { childList:true, subtree:true });
    } catch(e){}
    document.addEventListener('shopify:section:load', fetchAndApply);
  }

  if (document.readyState==='loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
})();
